import React from 'react';

export interface fieldsType {
    id: string;
    type: string;
    value: number | number[];
    overwrite: boolean;
}

export interface ConfigProps {
    contactListId: string;
    fields: fieldsType[];
}

const defaultSelect = {
    contactListId: '',
    fields: [],
};

const maps = {
    us: {
        contactListId: '1487185288',
        fields: [
            {
                id: '12606',
                type: 'multiple',
                value: [1],
                overwrite: false,
            },
            {
                id: '4423',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
        ],
    },
    ca: {
        contactListId: '1487185288',
        fields: [
            {
                id: '12606',
                type: 'multiple',
                value: [1],
                overwrite: false,
            },
            {
                id: '4424',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
        ],
    },
    za: {
        contactListId: '1388453392',
        fields: [
            {
                id: '8916',
                type: 'multiple',
                value: [21],
                overwrite: false,
            },
            {
                id: '4434',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
        ],
    },
    au: {
        contactListId: '1388453392',
        fields: [
            {
                id: '9104',
                type: 'multiple',
                value: [13],
                overwrite: false,
            },
            {
                id: '4433',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
        ],
    },
    kr: {
        contactListId: '396526985',
        fields: [
            {
                id: '10900',
                type: 'multiple',
                value: [6],
                overwrite: false,
            },
            {
                id: '4432',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
        ],
    },
    jp: {
        contactListId: '396526985',
        fields: [
            {
                id: '9120',
                type: 'multiple',
                value: [25],
                overwrite: false,
            },
            {
                id: '4431',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
        ],
    },
    eu: {
        contactListId: '1890208037',
        fields: [
            {
                id: '4427',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [48],
                overwrite: false,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [7],
                overwrite: false,
            },
        ],
    },
    uk: {
        contactListId: '105959553',
        fields: [
            {
                id: '4430',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [48],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [7],
                overwrite: false,
            },
        ],
    },
    de: {
        contactListId: '17911822',
        fields: [
            {
                id: '4425',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [48],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [7],
                overwrite: false,
            },
        ],
    },
    fr: {
        contactListId: '1972491857',
        fields: [
            {
                id: '4428',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [48],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [7],
                overwrite: false,
            },
        ],
    },
    it: {
        contactListId: '832112264',
        fields: [
            {
                id: '4429',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [48],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [7],
                overwrite: false,
            },
        ],
    },
    es: {
        contactListId: '1067045120',
        fields: [
            {
                id: '4426',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [48],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [7],
                overwrite: false,
            },
        ],
    },
};

const useConfig = (locale: string) => {
    const [conf, setConf] = React.useState<ConfigProps>(defaultSelect);

    React.useEffect(() => {
        setConf(maps[locale as keyof typeof maps]);
    }, [locale]);

    return conf;
};

export default useConfig;
